if (!customElements.get('bundle-selector')) {
  customElements.define(
    'bundle-selector',
    class BundleSelector extends HTMLElement {
      constructor() {
        super();
        this.options = this.querySelectorAll('.product-bundle__option');
        this.radios = this.querySelectorAll('input[type="radio"]');
        this.bundleRadio = this.querySelector('input[type="radio"][value="bundle"]');
        this.variantSelect = this.querySelector('[data-bundle-variant-select]');
        this.mainVariantSelect = this.querySelector('[data-bundle-main-variant-select]');
        this.isBundleActive = false;

        this.submitButton = document.querySelector('[id^="ProductSubmitButton-"]');
        this.submitButtonSpan = this.submitButton ? this.submitButton.querySelector('span') : null;
        if (this.submitButtonSpan) {
          this.submitButtonLabel = this.submitButtonSpan.textContent.split('—')[0].trim();

          this.submitButtonObserver = new MutationObserver(() => {
            if (!this.isBundleActive) return;
            const expected = `${this.submitButtonLabel} — ${this.dataset.bundlePrice}`;
            if (this.submitButtonSpan.textContent !== expected) {
              this.submitButtonSpan.textContent = expected;
            }
          });
          this.submitButtonObserver.observe(this.submitButtonSpan, { childList: true, characterData: true, subtree: true });
        }

        this.radios.forEach((radio) => radio.addEventListener('change', this.onOptionChange.bind(this)));
        this.onOptionChange();

        if (this.variantSelect) {
          this.variantSelect.addEventListener('change', () => {
            if (this.bundleRadio) this.bundleRadio.checked = true;
            this.onOptionChange();
          });
          this.variantSelect.addEventListener('click', (event) => event.stopPropagation());
        }

        if (this.mainVariantSelect) {
          this.mainVariantSelect.addEventListener('click', (event) => event.stopPropagation());
          this.mainVariantSelect.addEventListener('change', () => {
            if (this.bundleRadio) this.bundleRadio.checked = true;
            this.onOptionChange();
            this.selectMainVariant();
          });
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
          subscribe(PUB_SUB_EVENTS.variantChange, this.onMainVariantChange.bind(this));
        }
      }

      onMainVariantChange(event) {
        if (!this.mainVariantSelect || !event || !event.data || !event.data.variant) return;
        this.mainVariantSelect.value = event.data.variant.id;
        this.syncMatchingSize(this.mainVariantSelect, this.variantSelect);
      }

      syncMatchingSize(sourceSelect, targetSelect) {
        if (!sourceSelect || !targetSelect) return;

        const sourceOption = sourceSelect.selectedOptions[0];
        const sizeValue = sourceOption?.dataset.sizeValue;
        if (!sizeValue) return;

        const match = Array.from(targetSelect.options).find(
          (option) => option.dataset.sizeValue === sizeValue && !option.disabled
        );
        if (match && targetSelect.value !== match.value) {
          targetSelect.value = match.value;
        }
      }

      selectMainVariant() {
        const selectedOption = this.mainVariantSelect.selectedOptions[0];
        const values = (selectedOption?.dataset.optionValues || '').split('|').filter(Boolean);
        const variantSelects = document.querySelector('variant-selects');

        if (!variantSelects || !values.length) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', this.mainVariantSelect.value);
          window.location.href = url.toString();
          return;
        }

        const groupNames = [];
        variantSelects.querySelectorAll('input[type="radio"], select').forEach((input) => {
          if (!groupNames.includes(input.name)) groupNames.push(input.name);
        });

        let lastChangedInput = null;
        groupNames.forEach((name, index) => {
          const value = values[index];
          if (value === undefined) return;
          const input = variantSelects.querySelector(
            `[name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`
          );
          if (!input) return;
          if (input.type === 'radio') {
            input.checked = true;
          } else if (input.tagName === 'SELECT') {
            input.value = value;
          }
          lastChangedInput = input;
        });

        if (lastChangedInput) {
          lastChangedInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      onOptionChange() {
        const checked = this.querySelector('input[type="radio"]:checked');
        this.isBundleActive = checked ? checked.value === 'bundle' : false;
        this.options.forEach((option) => {
          option.classList.toggle('product-bundle__option--selected', option.contains(checked));
        });
        this.updateSubmitButtonPrice();
      }

      updateSubmitButtonPrice() {
        if (!this.submitButtonSpan || this.submitButtonLabel === undefined) return;
        const price = this.isBundleActive ? this.dataset.bundlePrice : this.dataset.singlePrice;
        if (!price) return;
        this.submitButtonSpan.textContent = `${this.submitButtonLabel} — ${price}`;
      }

      onCartUpdate(event) {
        if (!this.isBundleActive) return;
        if (!event || event.source !== 'product-form') return;

        const bundleVariantId = this.variantSelect ? this.variantSelect.value : null;
        if (!bundleVariantId) return;

        fetch(`${window.routes.cart_add_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: bundleVariantId, quantity: 1 }],
            sections: this.cartSectionsToRender(),
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.errors) return;
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (cart) cart.renderContents(response);
          });
      }

      cartSectionsToRender() {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        return cart ? cart.getSectionsToRender().map((section) => section.id) : [];
      }
    }
  );
}
